import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { OrangeButton } from 'components/Styled/v2/OrangeButton';

import './styles.scss';

const B2BCTA = () => {
  const { t } = useTranslation();

  return (
    <div className="b2b-cta">
      <div className="b2b-cta__container">
        <div className="b2b-cta__content">
          <h3 className="b2b-cta__title">{t('footer.b2bCTA.title')}</h3>
          <p className="b2b-cta__description">
            {t('footer.b2bCTA.description')}
          </p>
          <Link to="/travelpartners" className="b2b-cta__link">
            <OrangeButton className="b2b-cta__button">
              {t('footer.b2bCTA.button')}
            </OrangeButton>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default B2BCTA;
